<template>
  <div
    :class="[commonStore.getupDatingToast.showToast ? 'l-modal__bg' : '']"
  ></div>
  <div class="applied">
    <div id="header">
      <Tabs
        @tabchange="tabChange($event)"
        :tab-name1="APPLIED_TAB_LIST.get(1).name"
        :tab-name2="APPLIED_TAB_LIST.get(2).name"
        :tab-name3="APPLIED_TAB_LIST.get(3).name"
        :applied="projectStore.notification.applied"
        :progress="projectStore.notification.progress"
        :completed="projectStore.notification.completed"
      ></Tabs>
    </div>
    <div class="applied-contents">
      <section
        class="applied-contents-item-selection"
        :key="selectedStatus"
        v-on:scroll="handleScroll()"
      >
        <div v-for="(data, index) in displayList" :key="index">
          <ul class="product-img-wrap" @click="detail(data.id)">
            <div class="image-area">
              <img :src="data.image" />
              <div>
                <p class="project-title">{{ data.title }}</p>
                <p class="project-post-date">
                  投稿期間: {{ setDiaplayDate(data.post_started_at) }} 〜
                  {{ setDiaplayDate(data.post_ended_at) }}
                </p>
                <div class="state">
                  <span>{{ displayStatus(data.aplication_state) }}</span>
                </div>
              </div>
            </div>
          </ul>
        </div>
        <div
          :style="hiddenLoading()"
          v-show="loading"
          :class="[
            displayList && displayList.length > 0 ? 'loading' : 'first-loading',
          ]"
        >
          <img src="../assets/loading.gif" />
        </div>
      </section>

      <!-- </transition> -->
    </div>

    <div v-if="!loading && !displayList?.length" class="no-data">
      <img :src="NO_DATA.get(projectStore.selectedStatus).img" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from "vue-router";
import { nextTick, ref, onBeforeUnmount, watch } from "vue";
import { ProjectStore } from "../store/ProjectStore";
import { CommonStore } from "../store/CommonStore";
import {
  APPLICATION_STATE,
  APPLIED_TAB_LIST,
  APPLICATION_STATE_NAME,
  NO_DATA,
} from "../consts/common";
import Tabs from "./Tabs.vue";
import dayjs from "dayjs";

const projectStore = ProjectStore();
const infiteScroll = ref([false, false, false]);

const loading = ref(true);
const commonStore = CommonStore();
const selectedStatus = ref<number>(1);
const preselectedStatus = ref<number>(-1);
const displayList = ref(
  projectStore.appliedProjectList.get(projectStore.selectedStatus) || []
);

// DOM削除する前に既読情報更新
onBeforeUnmount(() => {
  if (
    projectStore.selectedStatus > 0 &&
    openedTab(projectStore.selectedStatus)
  ) {
    projectStore.readNotification({ step: projectStore.selectedStatus - 1 });
  }
});

const displayStatus = (state: number) => {
  return APPLICATION_STATE_NAME.find((v) => v.state == state)?.name;
};
// スクロール位置の保持、無限スクロール
const handleScroll = async () => {
  const container = document.getElementsByClassName(
    "applied-contents-item-selection"
  )[0] as HTMLElement;

  setScrollHeight(projectStore.selectedStatus);
  // setScrollHeight(projectStore.selectedStatus);
  if (projectStore.appliedAllCalled[projectStore.selectedStatus - 1]) return;
  if (loading.value || infiteScroll.value[projectStore.selectedStatus - 1])
    return;
  if (!container || !container.scrollHeight) return

  if (
    container.scrollHeight - (container.clientHeight + container.scrollTop) >
    120
  )
    return;

  loading.value = true;
  const initLoading = document.getElementsByClassName(
    "loading"
  )[0] as HTMLElement;
  initLoading.style.top =
    container.offsetTop + container.scrollHeight - 50 + "px";

  const pageNum = projectStore.appliedProjectListPageNum + 1;
  projectStore.setAppliedProjectListPageNum(pageNum);
  infiteScroll.value[projectStore.selectedStatus - 1] = true;

  await projectStore.getAppliedProjects(projectStore.selectedStatus);
  infiteScroll.value[projectStore.selectedStatus - 1] = false;
  displayList.value =
    projectStore.appliedProjectList.get(projectStore.selectedStatus) || [];
  loading.value = false;
};
const setScrollHeight = (selectedStatus: number) => {
  const item = document.getElementsByClassName(
    "applied-contents-item-selection"
  )[0] as HTMLElement;
  if (!item) return
  switch (selectedStatus) {
    case APPLICATION_STATE.APPLIED:
      commonStore.setAppliedProjectScrollHeight(
        projectStore.selectedStatus,
        item.scrollTop
      );
      break;
    case APPLICATION_STATE.WON:
      commonStore.setAppliedProjectScrollHeight(
        projectStore.selectedStatus,
        item.scrollTop
      );
      break;
    case 3:
      commonStore.setAppliedProjectScrollHeight(
        projectStore.selectedStatus,
        item.scrollTop
      );
      break;
  }
};
const getScrollHeight = () => {
  displayList.value =
    projectStore.appliedProjectList.get(projectStore.selectedStatus) || [];
  const item = document.getElementsByClassName(
    "applied-contents-item-selection"
  )[0] as HTMLElement;
  if (!item) return;
  item.scrollTo({
    top: commonStore.getAppliedProjectScrollHeight.get(
      projectStore.selectedStatus
    ),
    behavior: "auto",
  });
};

// 日付をYYYY年MM月DD日にフォーマットして返す
const setDiaplayDate = (date: string) => {
  return dayjs(new Date(date)).format("YYYY年MM月DD日");
};

const hiddenLoading = () => {
  if (!loading.value) {
    return "visibility: hidden;";
  } else {
    return "visibility: visible;";
  }
};

// 応募前: 0, 応募済: 1, 当選済: 2, 下書き送信済: 3, 投稿済: 4, 確認済: 5, 完了: 6, 落選: 10, キャンセル: 11, 応募不可: 12

const getProjectList = async (id: number) => {
  loading.value = true;
  await projectStore.getAppliedProjects(id).then(() => {
    displayList.value = projectStore.appliedProjectList.get(id) || [];
    loading.value = false;
  });
};

function openedTab(id: number) {
  switch (id) {
    case 1:
      return projectStore.notification.applied;
    case 2:
      return projectStore.notification.progress;
    case 3:
      return projectStore.notification.completed;
  }
}

const router = useRouter();
document.title = "応募案件";

async function tabChange(id: number) {
  if (preselectedStatus.value > 0 && openedTab(preselectedStatus.value)) {
    projectStore.readNotification({ step: preselectedStatus.value - 1 });
  }
  loading.value = true;

  displayList.value = [];

  preselectedStatus.value = selectedStatus.value;
  selectedStatus.value = id;
  projectStore.setSelectedStatus(id);
  // 初期表示済であれば一覧APIは呼ばない
  if (
    projectStore.appliedProjectList.get(projectStore.selectedStatus)?.length
  ) {
    displayList.value =
      projectStore.appliedProjectList.get(projectStore.selectedStatus) || [];
    loading.value = false;
  } else {
    await getProjectList(id);
  }
  await nextTick(() => {
    getScrollHeight();
  });
}
// const store = ProjectStore();

const detail = (id: number) => {
  projectStore.setSelectedId(id);
  router.push("/applied-project-detail");
};

watch(
  projectStore.appliedProjectList,
  () => {
    if (projectStore.appliedProjectList.get(projectStore.selectedStatus)) {
      displayList.value =
        projectStore.appliedProjectList.get(projectStore.selectedStatus) || [];
    }
  },

  { immediate: true, deep: true }
);
</script>

<style scoped lang="scss">
@import "../assets/style/_variables.scss";
@import "../assets/style/mixin.scss";

.applied {
  overflow-y: hidden;
  height: 100%;
}
#header {
  position: sticky;
  top: 0;
}

.applied-contents {
  width: 100%;
  height: calc(100% - 50px);
  display: flex;
}
.applied-contents-item-selection {
  top: 20px;
  overflow-y: auto;
  scrollbar-width: none;
  max-height: 100%;
  box-sizing: border-box;
  padding: 0px 10px 10px 10px;
  width: 100%;
  transition: all 0.8s ease;
}
.applied-contents-item-selection::-webkit-scrollbar {
  display: none;
}

input {
  display: none;
  border-radius: 90px;
  color: $white;
}

.product-img-wrap {
  list-style: none;
  padding-left: 0;
  width: 100%;
  background: #fafafa;
  border: 1px solid #d9d9d9;
  height: 130px;
  border-radius: 10px;
}
.image-area {
  display: flex;
  width: 100%;
  height: 100%;
  > img {
    min-width: 110px;
    min-height: 110px;
    object-fit: cover;
    margin: 10px 0 9px 9.5px;
    border-radius: 10px;
  }
  .project-title {
    margin: 10px 16px 0 14px;
    overflow-y: hidden;
    font-weight: 300;
    height: 43px;
    line-height: 21px;
    font-size: $FONT_SIZE_M;
    @include line-clamp(2);
    word-break: break-all;
  }
  .project-post-date {
    margin: 0 0 0 14px;
    font-size: $FONT_SIZE_S;
  }
  .state {
    margin-left: 14px;
    margin-top: 10px;
    display: inline-block;
    height: 18px;
    background: rgba(0, 116, 255, 0.07);
    border-radius: 2px;
    font-style: normal;
    font-weight: 300;
    font-size: $FONT_SIZE_S;
    line-height: 18px;
    padding: 3px 5px;
    span {
      color: $OMOT_COLOR;
    }
  }
  .infinite-loading {
    position: fixed !important;
    // width: 87%;
    width: 100%;
    max-width: 480px;
    height: 15px;
    bottom: 80px;
  }
}
.loading {
  display: flex;
  position: relative;
  justify-content: center;
  img {
    width: 10%;
    height: 10%;
  }
}
.first-loading {
  display: flex;
  width: 96%;
  max-width: 460px;
  position: fixed;
  justify-content: center;
  top: 50%;
  img {
    width: 10%;
    height: 10%;
  }
}
.l-modal__bg {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.75);
  position: fixed;
  top: 0;
  left: 0;
  text-align: center;
  z-index: 99;
}
</style>
